import { render, staticRenderFns } from "./IndicatorsMenu.vue?vue&type=template&id=9e466974&scoped=true"
import script from "./IndicatorsMenu.vue?vue&type=script&lang=js"
export * from "./IndicatorsMenu.vue?vue&type=script&lang=js"
import style0 from "./IndicatorsMenu.vue?vue&type=style&index=0&id=9e466974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e466974",
  null
  
)

export default component.exports